import React, { useEffect, useState } from "react";
import "./index.scss";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { NavLink } from "react-router-dom";

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    getProjects();
  }, []);

  const getProjects = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "projects"));
      setProjects(querySnapshot.docs.map((doc) => doc.data()));
    } catch (e) {
      setError("Something went wrong! Couldn't fetch data at this moment");
    } finally {
      setLoading(false);
    }
  };

  const renderProjects = (projects) => {
    return (
      <div className="images-container">
        {projects.length !== 0 ? (
          projects.map((project, idx) => {
            return (
              <NavLink
                key={project.name}
                to={`${project.name}`}
              >
                <div className="image-box" key={idx}>
                  {/* Decorative: the project name next to it already labels the link */}
                  <img src={project.logo} alt="" />
                  <div className="project-content">
                    <div className="project-name">{project.name}</div>
                    <div className="project-desc">{project.description[0]}</div>
                  </div>
                </div>
              </NavLink>
            );
          })
        ) : (
          <>No Projects Found</>
        )}
      </div>
    );
  };

  const renderShimmer = () => {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  };

  const renderError = () => {
    return (
      <div className="loader-container">
        <div className="error"> {error}</div>
      </div>
    );
  };

  return (
    <>
      <div className="container projects-page">
        <div className="text-zone">
          <h1>Projects</h1>
          <p>
            A selection of Flutter mobile apps, AI-powered apps and full-stack
            web projects I've built, from cross-platform Android and iOS apps
            with Firebase and Supabase backends to MERN stack web
            applications. Many of them are open-source, so if something piques
            your interest, check out the code and feel free to contribute.
          </p>
          {loading
            ? renderShimmer()
            : error
            ? renderError()
            : renderProjects(projects)}
        </div>
      </div>
    </>
  );
};

export default Projects;
